import {
    EVENTO_COTIZACION_CONFIG,
    EVENTO_COTIZACION_CONFIG_DEFAULT,
    USUARIO_DESCONOCIDO,
} from "../constants/bitacoraCotizacion.constants";
import type {
    BitacoraCotizacionItem,
    EventoCotizacionConfig,
    FilaBitacoraCotizacion,
} from "../types/bitacoraCotizacion.types";

export const obtenerConfigEvento = (idEvento?: number | null): EventoCotizacionConfig =>
    EVENTO_COTIZACION_CONFIG[idEvento ?? 0] ?? EVENTO_COTIZACION_CONFIG_DEFAULT;

export const formatearFechaBitacora = (fecha: string): string =>
    new Date(fecha).toLocaleString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });

export const obtenerNombreUsuario = (item: BitacoraCotizacionItem): string =>
    item.usuario ? `${item.usuario.nombre} ${item.usuario.apellidos}` : USUARIO_DESCONOCIDO;

export const normalizarFilasBitacoraCotizacion = (
    bitacora: BitacoraCotizacionItem[]
): FilaBitacoraCotizacion[] => {
    const ordenada = [...bitacora].sort((a, b) => a.id - b.id);

    return ordenada.map((item, index) => {
        const config = obtenerConfigEvento(item.evento?.id ?? item.id_evento);
        const nombreUsuario = obtenerNombreUsuario(item);

        return {
            id: item.id,
            titulo: item.evento?.nombre ?? "Evento",
            color: config.color,
            icon: config.icon,
            fecha: formatearFechaBitacora(item.created_at),
            nombreUsuario,
            descripcion: (
                <>
                    <strong>Por:</strong> {nombreUsuario}
                    {item.descripcion && (
                        <>
                            <br />
                            {item.descripcion}
                        </>
                    )}
                </>
            ),
            esPrimero: index === 0,
            esUltimo: index === ordenada.length - 1,
        };
    });
};